import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Modal, Button, Row, Col, Icon, Tooltip } from 'antd';
@inject('ecodeDemoStore')
@observer
class App extends React.Component {
  onCancel = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ visibleOfDetail: false });
  }
  render() {
    const { formPrefixCls, formItemLayout, ecodeDemoStore: { visibleOfDetail, activitykey } } = this.props;
    let { ecodeDemoStore: { detail } } = this.props;
    detail = toJS(detail)
    const { title, thumbsup, stars, downloadCounts } = detail;
    let detailKeys = activitykey === 'downloadlog' ? [
      { key: 'id', name: 'ID：' },
      { key: 'userId', name: '用户ID：' },
      { key: 'userName', name: '用户名：', textElli: true },
      { key: 'userMobile', name: '手机号：' },
      { key: 'userEmail', name: '邮箱：' },
      { key: 'companyName', name: '公司名：' },
      { key: 'ecodeVersion', name: 'ecode版本：' },
      { key: 'ecologyVersion', name: 'ecology版本：' },
      { key: ['createDate', 'createTime'], name: '创建时间：' },
      { key: 'serverIp', name: '服务端IP：' },
      { key: 'clientIp', name: '客户端IP：' },
      { key: 'requestIp', name: '请求IP：' },
    ] :[
      { key: 'folderId', name: '文件id：',
        render: (detail) => <a href={`https://e-cloudstore.com/doc.html?appId=${detail.folderId}`} target="_blank">{detail.folderId}</a>
      },
      { key: 'userID', name: '用户ID：' },
      { key: 'account', name: '账号：' },
      { key: 'userName', name: '用户名：', textElli: true },
      { key: 'email', name: '邮箱：' },
      { key: 'company', name: '公司名：' },
      { key: 'ecodeVersion', name: 'ecode版本：' },
      { key: 'ecologyVersion', name: 'ecology版本：' },
      { key: 'introduction', name: '简介：', singleLine: true },
      { key: 'description', name: '详细描述：', singleLine: true },
      { key: ['createDate', 'createTime'], name: '创建时间：' },
      { key: ['modifyDate', 'modifyTime'], name: '修改时间：' },
      { key: 'serverIp', name: '服务端IP：' },
      { key: 'clientIp', name: '客户端IP：' },
      { key: 'requestIp', name: '请求IP：' },
    ];
    if (activitykey === 'appmanage') {
      const appDetail = [
        {
          key: 'attr__caseType',
          name: '案例类型',
          render: (record) => {
            if (record.attr && record.attr.caseType) {
              if (record.attr.caseType === 'app') return '应用类';
              return '案例类';
            }
            return '';
          }
        },
        { key: 'attr__charging', name: '价格', render: (record) => `¥ ${record.attr ? record.attr.charging: ''}` },
        {
          key: 'attr__headquarters',
          name: '是否总部开发',
          render: (record) => {
            if (record.attr && record.attr.headquarters) {
              if (record.attr.headquarters === 'y') return '总部';
              return '非总部';
            }
            return '';
          }
        },
      ]
      detailKeys = detailKeys.concat(appDetail);
    }
    const labelColXs = formItemLayout.labelCol.xs;
    const labelColSm = formItemLayout.labelCol.sm;
    const wrapperColXs = formItemLayout.wrapperCol.xs;
    const wrapperColSm = formItemLayout.wrapperCol.sm;
    const titleCon = (<div className="sys-ecode-detail-title">
      <span>{title}</span>
      {
        activitykey !== 'downloadlog' && ([
          <Tooltip placement="bottom" title="点赞" key="like">
            <Icon type="like" />({thumbsup})
          </Tooltip>,
          <Tooltip placement="bottom" title="收藏" key="stars">
            <Icon type="star" />({stars})
          </Tooltip>,
          <Tooltip placement="bottom" title="下载" key="download">
            <Icon type="download" />({downloadCounts})
          </Tooltip>,
        ])
      }
    </div>);
    return (
      <Modal
        title={titleCon}
        visible={visibleOfDetail}
        onCancel={this.onCancel}
        width={950}
        zIndex={1000}
        footer={
          [(<Button onClick={this.onCancel} key="detailCancel">返回</Button>)]
        }
      >
        <Row className={`${formPrefixCls}-row`}>
          {
            detailKeys && detailKeys.map((item) => {
              let content = ''
              if (typeof item.key === 'string') {
                content = detail[item.key];
                if (item.render) content = item.render(detail);
              } else {
                content = item.key.map((k) => `${detail[k]} `);
              }
              const otherParams = item.textElli ? { title: content } : {};
              return (
                <Col span={item.singleLine ? 24 : 12} key={item.key}>
                  <Row>
                    <Col xs={labelColXs} sm={item.singleLine ? { span: labelColSm.span / 2 } : labelColSm}>
                      <div className="sys-ecode-detail-label">{item.name}</div>
                    </Col>
                    <Col xs={wrapperColXs} sm={item.singleLine ? { span: 24 - (labelColSm.span / 2) } : wrapperColSm}>
                      <div className={`sys-ecode-detail-wrapper${item.singleLine ? '-mul' : ''} ${item.textElli && 'text-elli'}`} {...otherParams}>
                        { content }
                      </div>
                    </Col>
                  </Row>
                </Col>
            )})
          }
        </Row>
      </Modal>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/Detail.js